import { render, staticRenderFns } from "./4.vue?vue&type=template&id=19489f4d&scoped=true"
import script from "./4.vue?vue&type=script&lang=js"
export * from "./4.vue?vue&type=script&lang=js"
import style0 from "./4.vue?vue&type=style&index=0&id=19489f4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19489f4d",
  null
  
)

export default component.exports